// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3AAqT","title":"FrontImage_title__3e2XQ"};